import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { ShoppingBag, User, Menu, X, Search, LogOut, Heart } from 'lucide-react';
import { useCart, useAuth, useWishlist } from '../context/AppContext';
export default function Navbar() {
const { cartCount } = useCart();
const { wishlistCount } = useWishlist();
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQ, setSearchQ] = useState('');

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handler);
    handler();
    return () => window.removeEventListener('scroll', handler);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  const handleSearch = (e) => {
    e.preventDefault();

    if (searchQ.trim()) {
      navigate(`/collections?search=${encodeURIComponent(searchQ.trim())}`);
      setSearchOpen(false);
      setSearchQ('');
    }
  };

  const handleAccountClick = () => {
    if (user) {
      navigate('/my-orders');
    } else {
      navigate('/login');
    }
  };

  const handleLogout = () => {
    logout();
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('admin');
    navigate('/login');
  };

  const navLinks = [
    { to: '/', label: 'Home' },
    { to: '/collections', label: 'Collections' },
    { to: '/about', label: 'About' },
    { to: '/contact', label: 'Contact' },
  ];

  return (
    <>
      <style>{`
      * {
  box-sizing: border-box;
}

html,
body {
  width: 100%;
  overflow-x: hidden;
}

#root {
  width: 100%;
  overflow-x: hidden;
}
        .navbar {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          width: 100%;
          overflow-x: hidden;
          
          overflow-x: hidden;
          z-index: 999;
          background: transparent;
          border-bottom: 1px solid rgba(255,255,255,0.08);
          transition: all 0.35s ease;
        }

        .navbar.scrolled,
        .navbar.search-open { 
          background: #4A0F1F(250,247,242,0.96);
          backdrop-filter: blur(14px);
          border-bottom: 1px solid rgba(201,169,110,0.22);
          box-shadow: 0 10px 25px rgba(0,0,0,0.06);
        }

        .nav-inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 24px;
          height: 72px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .nav-logo {
          display: flex;
          align-items: center;
          gap: 12px;
          font-family: 'Cormorant Garamond', serif;
          font-size: 22px;
          font-weight: 500;
          color: #ba8a32;
        }
          letter-spacing: 1.3px;
          text-decoration: none;
          transition: all .3s ease;
        }

        .nav-logo:hover {
          transform: scale(1.03);
          color: #C9A96E;
        }

        .nav-logo-img {
          width: 44px;
          height: 44px;
          object-fit: contain;
          flex-shrink: 0;
          border-radius: 50%;
        }

        .nav-links {
          display: flex;
          gap: 36px;
          list-style: none;
        }

        .nav-links a {
          position: relative;
          font-size: 12px;
          letter-spacing: 1.7px;
          text-transform: uppercase;
          color: ${scrolled || searchOpen ? 'var(--text-mid)' : 'color: #C9A96E;(255,255,255,0.82)'};
          text-decoration: none;
          padding-bottom: 7px;
          transition: color .3s ease;
        }

        .nav-links a::after {
          content: "";
          position: absolute;
          left: 0;
          bottom: 0;
          width: 0;
          height: 1px;
          background: #C9A96E;
          transition: width .35s ease;
        }

        .nav-links a:hover,
        .nav-links a.active {
          color: ${scrolled || searchOpen ? 'var(--maroon)' : 'color:  #E5C27A'};
        }

        .nav-links a:hover::after,
        .nav-links a.active::after {
                  left: 0;
        right: 0;
        width: 100%;
        overflow-x: hidden;
        }

        .nav-actions {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .nav-icon-btn {
          background: transparent;
          border: none;
          padding: 6px;
          color: #dfba76;
          position: relative;
          display: flex;
          align-items: center;
          cursor: pointer;
          transition: all .25s ease;
        }

        .nav-icon-btn:hover {
        color: #D4AF37;;
          transform: translateY(-1px);
        }

        .cart-badge {
          position: absolute;
          top: -5px;
          right: -6px;
          background: var(--maroon);
          color: white;
          border-radius: 50%;
          width: 17px;
          height: 17px;
          font-size: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid #E5C27A;
        }

        .search-bar {
          position: absolute;
          top: 72px;
          left: 0;
          right: 0;
          background: rgba(250,247,242,0.97);
          backdrop-filter: blur(12px);
          border-bottom: 1px solid var(--border);
          padding: 16px 24px;
          z-index: 998;
          animation: searchDrop .3s ease;
        }

        .search-bar input {
          left: 0;
          right: 0;
          width: 100%;
          overflow-x: hidden;
          max-width: 640px;
          margin: 0 auto;
          display: block;
          padding: 12px 18px;
          border: 1px solid rgba(153, 103, 10, 0.45);
          border-radius: 30px;
          font-size: 14px;
          background: white;
          outline: none;
        }

        .search-bar input:focus {
          border-color: var(--champagne);
          box-shadow: 0 0 0 3px rgba(129, 90, 16, 0.14);
        }

        @keyframes searchDrop {
          from { opacity: 0; transform: translateY(-12px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .mobile-menu {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow-y: auto;
  background: #faf7f2;
  z-index: 1000;
  flex-direction: column;
  padding: 24px;
  box-sizing: border-box;
}
        

        .mobile-menu.open {
          display: flex;
        }

        @keyframes mobileFade {
          from { opacity: 0; transform: translateY(-8px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .mobile-logo {
          font-family: 'Cormorant Garamond', serif;
          font-size: 24px;
          color: var(--maroon);
        }

        .mobile-close {
          background: white;
          border: 1px solid var(--border);
          width: 40px;
          height: 40px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: var(--maroon);
        }

        .mobile-link {
          font-size: 26px;
          font-family: 'Cormorant Garamond', serif;
          font-weight: 300;
          color: var(--text-dark);
          padding: 16px 0;
          border-bottom: 1px solid var(--border);
          transition: color .25s ease;
          text-decoration: none;
        }

        .mobile-link {
  color: #4a0f1d;
  font-weight: 500;
}
        }

        .mobile-cart-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }

        .hamburger {
          display: none;
        }

        @media(max-width: 768px) {
          .nav-links {
            display: none;
          }

          .hamburger {
            display: flex !important;
          }

          .nav-inner {
            height: 64px;
            padding: 0 18px;
          }

          .nav-logo {
            font-size: 19px;
          }

          .nav-logo-img {
            width: 38px;
            height: 38px;
          }

          .search-bar {
            top: 64px;
          }
        }
      `}</style>

      <nav className={`navbar${scrolled ? ' scrolled' : ''}${searchOpen ? ' search-open' : ''}`}>
        <div className="nav-inner">
          <Link to="/" className="nav-logo">
            <img src="/logo.jpg" alt="Anvith Dazzle" className="nav-logo-img" />
            Anvith Dazzle
          </Link>

          <ul className="nav-links">
            {navLinks.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className={location.pathname === l.to ? 'active' : ''}>
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>

          <div className="nav-actions">
            <button className="nav-icon-btn" onClick={() => setSearchOpen((o) => !o)} title="Search">
              <Search size={20} />
            </button>

            <button className="nav-icon-btn" onClick={handleAccountClick} title={user ? 'My Orders' : 'Login'}>
              <User size={20} />
            </button>

            {user && (
              <button className="nav-icon-btn" onClick={handleLogout} title="Logout">
                <LogOut size={19} />
              </button>
            )}

            <button
  className="nav-icon-btn"
  onClick={() => navigate('/wishlist')}
  title="Wishlist"
>
  <Heart size={20} />

  {wishlistCount > 0 && (
    <span className="cart-badge">
      {wishlistCount}
    </span>
  )}
</button>

            <button className="nav-icon-btn" onClick={() => navigate('/cart')} title="Cart">
              <ShoppingBag size={20} />
              {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
            </button>

            <button className="nav-icon-btn hamburger" onClick={() => setMenuOpen((o) => !o)} title="Menu">
              {menuOpen ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>

        {searchOpen && (
          <div className="search-bar">
            <form onSubmit={handleSearch}>
              <input
                autoFocus
                value={searchQ}
                onChange={(e) => setSearchQ(e.target.value)}
                placeholder="Search for rings, chains, bracelets..."
              />
            </form>
          </div>
        )}
      </nav>

      <div className={`mobile-menu${menuOpen ? ' open' : ''}`}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 44 }}>
          <span className="mobile-logo">Anvith Dazzle</span>

          <button className="mobile-close" onClick={() => setMenuOpen(false)}>
            <X size={22} />
          </button>
        </div>

        {navLinks.map((l) => (
          <Link key={l.to} to={l.to} className="mobile-link">
            {l.label}
          </Link>
        ))}

        <div style={{ marginTop: 34, display: 'flex', flexDirection: 'column', gap: 12 }}>
          
          <button
  className="btn btn-outline btn-full"
  onClick={() => {
    navigate('/wishlist');
    setMenuOpen(false);
  }}
>
  ❤️ Wishlist ({wishlistCount})
</button>
          
          <button
            className="btn btn-primary btn-full mobile-cart-btn"
            onClick={() => {
              navigate('/cart');
              setMenuOpen(false);
            }}
          >
            <ShoppingBag size={16} />
            Cart ({cartCount})
          </button>

          {user ? (
            <>
              <button
                className="btn btn-outline btn-full"
                onClick={() => {
                  navigate('/my-orders');
                  setMenuOpen(false);
                }}
              >
                My Orders
              </button>

              <button
                className="btn btn-outline btn-full"
                onClick={() => {
                  handleLogout();
                  setMenuOpen(false);
                }}
              >
                Logout
              </button>
            </>
          ) : (
            <button
              className="btn btn-outline btn-full"
              onClick={() => {
                navigate('/login');
                setMenuOpen(false);
              }}
            >
              Login
            </button>
          )}
        </div>
      </div>
    </>
  );
}